import React from 'react';
import styles from './Button.module.scss';

const StandardButton = ({ children, icon, outlined, ...props }) => {
  const { onClick, disabled, type = 'button' } = props;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      {...props}
      className={
        outlined
          ? styles['standard-button-outlined']
          : styles['standard-button']
      }
    >
      <div className={styles['text']}>{children}</div>
      {icon ? <div className={styles['icon']}>{icon}</div> : null}
    </button>
  );
};

export default StandardButton;
